import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

import { numberValidator, specialCharValidator, uppercaseValidator } from './password-validators';

/**
 * Combined validator directive for password character requirements
 * Validates uppercase, number, and special character requirements separately
 * Returns all validation errors that fail
 */
@Directive({
  selector: '[appPasswordValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PasswordValidatorDirective),
      multi: true,
    },
  ],
})
export class PasswordValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const errors: ValidationErrors = {
      ...uppercaseValidator(control),
      ...numberValidator(control),
      ...specialCharValidator(control),
    };

    return Object.values(errors).some(error => error != null) ? errors : null;
  }
}
